// extracted by mini-css-extract-plugin
module.exports = {"submit":"Form-module--submit--3379i"};